import { US_STATES_AND_TERRITORIES } from '@onefootprint/core';

const formatState = (state?: string, emptyText = '-') => {
  const possibleState = US_STATES_AND_TERRITORIES.find(s => s.value === state);
  return possibleState?.label || emptyText;
};

export default formatState;
